// extracted by mini-css-extract-plugin
module.exports = {"dialog":"Dialog_dialog__XULz2"};